import '../../../scss/landing/dashbord/index.scss';
import { Router } from "../../common/router";
import { sendForm } from "../../common/contactForm";
document.addEventListener('DOMContentLoaded', function () {
    sendContactForm();
    var tabLinks = Array.from(document.querySelectorAll('.tablinks'));
    var tabContents = Array.from(document.querySelectorAll('.tabcontent'));
    tabLinks.map(function (link) {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            var tabName = link.getAttribute('data-tab');
            openTab(e, tabName);
        });
    });
    var openTab = function (e, tabName) {
        tabContents.map(function (content) {
            content.style.display = 'none';
        });
        tabLinks.map(function (link) {
            link.className = link.className.replace(' active', '');
        });
        var tabElement = document.querySelector("#" + tabName);
        tabElement.style.display = 'block';
        e.currentTarget.className += ' active';
    };
    if (tabLinks.length > 0) {
        tabLinks[0].click();
    }
});
var sendContactForm = function () {
    var form = document.querySelector('#contactForm');
    var button = form.querySelector('#contactButton');
    if (!form || !button) {
        return;
    }
    button.addEventListener('click', function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        var firstName = (_a = form.querySelector('#firstname')) === null || _a === void 0 ? void 0 : _a.value;
        var lastName = (_b = form.querySelector('#lastname')) === null || _b === void 0 ? void 0 : _b.value;
        var businessEmailAddress = (_c = form.querySelector('#businessEmailAddress')) === null || _c === void 0 ? void 0 : _c.value;
        var company = (_d = form.querySelector('#company')) === null || _d === void 0 ? void 0 : _d.value;
        var jobTitle = (_e = form.querySelector('#jobTitle')) === null || _e === void 0 ? void 0 : _e.value;
        var telephone = (_f = form.querySelector('#telephone')) === null || _f === void 0 ? void 0 : _f.value;
        var comment = (_g = form.querySelector('#comment')) === null || _g === void 0 ? void 0 : _g.value;
        var interest = (_h = form.querySelector('#interest')) === null || _h === void 0 ? void 0 : _h.value;
        var country = (_j = form.querySelector('#country')) === null || _j === void 0 ? void 0 : _j.value;
        var body = {
            'first_name': firstName,
            'last_name': lastName,
            'email': businessEmailAddress,
            'company': company,
            'phone_number': telephone,
            'job_title': jobTitle,
            'interest': interest,
            'country': country,
            'comment': comment
        };
        var path = Router.generate('data_products_dashboard_contact_create');
        sendForm(form, button, path, body);
    });
};
